import React, { lazy } from 'react';
import './GetStarted.sass';
import Config from '../../../../../base/config/Config';
import i18n from '../../../../../i18n';
const Title = lazy(() => import('../../../../component/title/Title'));
const Message = lazy(() => import('../../../../component/message/Message'));
const Button = lazy(() => import('../../../../component/button/Button'));

function GetStarted() {
    return (
        <div className="GetStartedArea">
            <div className="GetStartedMessageArea">
                <div className="GetStartedTitle">
                    <Title size="Big" type="Primary" text={i18n.t('Your job on social media doesn’t need to be lonely anymore.')} />
                </div>
                <div className="GetStartedMessage">
                    <Message size="Giant" type="Primary" text={i18n.t('Agencies who work performance on social media, brands who are increasing their presence on social media, main publishers who use Swonkie to reach more people and freelancers who choose us to get more clients.')} />
                    <Message size="Giant" type="PrimaryBold" text={i18n.t('Let’s create your account?')} />
                </div>
                <div className="GetStartedButton">
                    <a href={`${Config.appHost}register?utm_source=website&utm_medium=homepage&utm_campaign=cta-5`}> <Button size="Big" type="Tertiary" text={i18n.t('Yes, i want to create my account')} /> </a>
                </div>
            </div>
        </div>
    );
}

export default GetStarted;
